export default __webpack_public_path__ + "71c935c9cf4b0f6d1bef679fd6eae89e.png";